import {
	PRIORITY_TYPE,
	ASSIGNEE_TYPE,
	STATUS_TYPE,
	SPRINT_TYPE,
	NUMBER_CF_TYPE,
	STORY_POINT_ESTIMATE_CF_TYPE,
	CATEGORY_TYPE,
} from '@atlassian/jira-platform-field-config/src/index.tsx';
import type {
	GroupContextField,
	OptimisticFieldSet,
	PriorityOptimisticResponse,
} from './types.tsx';

export const SUPPORTED_FIELD_TYPES: Set<string> = new Set([
	PRIORITY_TYPE,
	ASSIGNEE_TYPE,
	STATUS_TYPE,
	SPRINT_TYPE,
	NUMBER_CF_TYPE,
	STORY_POINT_ESTIMATE_CF_TYPE,
	CATEGORY_TYPE,
]);

export const isCreateIssueSupportedForFieldType = (fieldType?: string | null) =>
	Boolean(fieldType && SUPPORTED_FIELD_TYPES.has(fieldType));

export const convertFieldToIssueCreateInput = ({
	fieldType,
	fieldValue,
	fieldId,
}: GroupContextField) => {
	if (fieldValue === null) {
		return null;
	}

	switch (fieldType) {
		case PRIORITY_TYPE:
			return { priority: { priorityId: fieldValue } };
		case ASSIGNEE_TYPE:
			return {
				singleSelectUserPickerFields: [{ fieldId, user: { accountId: fieldValue } }],
			};
		case STATUS_TYPE:
			return { status: { statusId: fieldValue } };
		case STORY_POINT_ESTIMATE_CF_TYPE:
		case NUMBER_CF_TYPE:
			return { numberFields: [{ fieldId, value: fieldValue }] };
		case CATEGORY_TYPE:
			return {
				singleSelectFields: [
					{
						fieldId,
						option: { id: fieldValue },
					},
				],
			};
		case SPRINT_TYPE:
			return { sprintsField: { fieldId, sprints: [{ sprintId: fieldValue }] } };
		default:
			return null;
	}
};

export const toOptimisticField = (
	issueId: string,
	{ fieldId, fieldType, optimisticResponse }: GroupContextField,
): OptimisticFieldSet => {
	switch (optimisticResponse?.type) {
		case PRIORITY_TYPE:
			return toOptimisticPriority({
				issueId,
				fieldId,
				fieldType,
				priority: optimisticResponse,
			});
		default:
			return null;
	}
};

const toOptimisticPriority = ({
	issueId,
	fieldId,
	fieldType,
	priority,
}: {
	issueId: string;
	fieldId: string;
	fieldType: string;
	priority: PriorityOptimisticResponse;
}): OptimisticFieldSet => ({
	node: {
		fieldSetId: 'priority',
		type: 'priority',
		fields: {
			edges: [
				{
					node: {
						__typename: 'JiraPriorityField',
						__isJiraIssueField: 'JiraPriorityField',
						fieldId,
						id: `${issueId}/priority`,
						type: fieldType,
						name: 'Priority',
						priority: {
							id: priority.id,
							name: priority.name,
							iconUrl: priority.iconUrl,
						},
					},
				},
			],
		},
	},
});
